module.exports = __webpack_public_path__ + "static/RotatePhoneBackground-0cb5e3c7bd96d6cf3cd164dbe6953b58.png";